import { Link } from 'react-router-dom';

type Kind = 'orcamento' | 'contato' | 'newsletter' | 'guia';

const TEXTS: Record<Kind, string> = {
  orcamento:
    'Usamos seus dados apenas para analisar o seu pedido e enviar o orçamento solicitado.',
  contato: 'Usamos seus dados apenas para responder à sua mensagem.',
  newsletter:
    'Ao se inscrever, você concorda em receber nossos conteúdos por e-mail e pode cancelar quando quiser.',
  guia: 'Usamos seus dados para enviar o guia solicitado e responder ao seu contato.',
};

interface LgpdNoticeProps {
  kind?: Kind;
  className?: string;
}

/** Aviso de tratamento de dados (LGPD, art. 9º) exibido junto de cada formulário. */
export default function LgpdNotice({ kind = 'contato', className }: LgpdNoticeProps) {
  return (
    <p className={'font-body text-xs leading-relaxed opacity-80 ' + (className || '')}>
      {TEXTS[kind]} Tratamos seus dados conforme a LGPD (Lei 13.709/2018) e você pode pedir acesso, correção ou
      exclusão a qualquer momento. Leia a{' '}
      <Link to="/politica-privacidade" className="underline font-semibold">
        Política de Privacidade
      </Link>
      .
    </p>
  );
}
